<template>
  <div>
    <div class="searchBox">
      <div class="searchLeft">
        <el-input
          size="medium"
          v-model="searchForm.channelName"
          placeholder="请输入渠道名称"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">查询</el-button>
      </div>
      <div class="searchRight">
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addFunc">增加</el-button>
      </div>
    </div>
    <el-table
      border
      :data="tableData"
      height="73vh"
      style="width: 100%">
      <el-table-column
        prop="id"
        label="渠道编号">
      </el-table-column>
      <el-table-column
        prop="channelName"
        label="渠道名称">
      </el-table-column>
      <el-table-column
        prop="channelUserId"
        label="渠道用户ID">
      </el-table-column>
      <el-table-column
        prop="saleNum"
        label="已销售有效算力">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间">
        <template slot-scope="scope">
          <span>{{$selfFunc.dayjsFunc(scope.row.createTime)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="eidt(scope.row)"><i class="el-icon-view" style="margin-right:3px;"></i>编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[20, 50, 100, 500]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="ruleForm.id?'编辑':'新增'"
      :visible.sync="dialogVisible"
      class="modulBox"
      width="750px">
      <div class="modul_box">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="渠道名称" prop="channelName">
                <el-input placeholder="请输入渠道名称" v-model.trim="ruleForm.channelName" style="width:220px" type="text" ></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <el-form-item label="渠道ID" prop="channelUserId">
                <el-input placeholder="请输入渠道用户ID" :disabled="ruleForm.id?true:false" v-model.trim="ruleForm.channelUserId" style="width:220px" type="number" ></el-input>
              </el-form-item>
            </div>
          </el-col>
          <div class="bigBox">
            <div class="title_box"><div>销售挖矿</div> <div @click="addApis" style="cursor: pointer;">+新增</div></div>
            <div class="samll_title" v-for="(item,index) in ruleForm.apiAr" :key="item.shareName+index">
              <div class="lable">
                <el-form-item label="分成类型" :prop="'apiAr.'+index+'.shareName'" :rules="rules.shareName">
                  <el-input v-model.trim="item.shareName" style="width:100px" type="text" ></el-input>
                </el-form-item>
              </div>
              <div class="lable">
                <el-form-item label="用户ID" :prop="'apiAr.'+index+'.sysUserId'" :rules="rules.sysUserId">
                  <el-input v-model.trim="item.sysUserId" style="width:100px" type="number" ></el-input>
                </el-form-item>
              </div>
              <div class="lable">
                <el-form-item label="分成比例" :prop="'apiAr.'+index+'.shareRatio'" :rules="rules.shareRatio">
                  <el-input v-model.trim="item.shareRatio" style="width:100px" type="number" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
                </el-form-item>
              </div>
              <div class="delBtn" @click="delAdd(index)">删除</div>
            </div>

            <div class="title_box"><div>封装挖矿</div> <div @click="addApisTwo" style="cursor: pointer;">+新增</div></div>
            <div class="samll_title" v-for="(item,index) in ruleForm.apiArTwo" :key="index+1">
              <div class="lable">
                <el-form-item label="分成类型" :prop="'apiArTwo.'+index+'.shareName'" :rules="rules.shareName">
                  <el-input v-model.trim="item.shareName" style="width:100px" type="text" ></el-input>
                </el-form-item>
              </div>
              <div class="lable">
                <el-form-item label="用户ID" :prop="'apiArTwo.'+index+'.sysUserId'" :rules="rules.sysUserId">
                  <el-input v-model.trim="item.sysUserId" style="width:100px" type="text" ></el-input>
                </el-form-item>
              </div>
              <!-- <div class="lable">
                <el-form-item label="用户ID" :prop="'apiArTwo.'+index+'.sysUserId'" :rules="rules.sysUserId">
                  <el-input v-model.trim="item.sysUserId" style="width:100px" type="number" ></el-input>
                </el-form-item>
              </div> -->
              <div class="lable">
                <el-form-item label="分成比例" :prop="'apiArTwo.'+index+'.shareRatio'" :rules="rules.shareRatio">
                  <el-input v-model.trim="item.shareRatio" style="width:100px" type="number" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
                </el-form-item>
              </div>
              <div class="delBtn" @click="delAddTwo(index)">删除</div>
            </div>
          </div>
        </el-form>
        <div class="nodeBox">
          <el-transfer
            v-model="relateTableArr"
            :titles="['请选择节点', '已选节点']"
            :data="dataArr" @change="handleChange">
          </el-transfer>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    console.log(this.tableData)
    return {
      dataArr:[],
      relateTableArr: [],
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:20,
        channelName: ''
      },
      tableData: [],
      dialogVisible: false,
      ruleForm:{
        id:'',
        channelName: '',
        channelId: '',
        apiAr: [],
        apiArTwo: []
      },
      apiAr:{
        sysUserId:'',
        shareName: '',
        shareRatio: ''
      },
      apiArTwo:{
        sysUserId:'',
        shareName: '',
        shareRatio: ''
      },
      
      rules:{
        channelName: [
          { required: true, message: '请输入渠道名称', trigger: 'blur' },
        ],
        channelUserId: [
          { required: true, message: '请输入渠道用户ID', trigger: 'blur' },
        ],
        shareName: [
          { required: true, message: '请输入分成类型', trigger: 'blur' },
        ],
        sysUserId: [
          { required: true, message: '请输入用户ID', trigger: 'blur' },
        ],
        shareRatio: [
          { required: true, message: '请输入分成比例', trigger: 'blur' },
        ]
      }
    };
  },
  created() {
    this.getTableList()
    this.addApis();
    this.nodeList()
  },
  methods: {
    handleChange(value, direction, movedKeys) {
      this.relateTableArr = value
    },
    submitForm(formName) {
      console.log(this.ruleForm)
      let _this = this
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let list = JSON.stringify(_this.ruleForm.apiAr)
          let listTwo = JSON.stringify(_this.ruleForm.apiArTwo)
          let data = {
            channelName: _this.ruleForm.channelName,
            channelUserId:_this.ruleForm.channelUserId,
            nodeListStr:JSON.stringify(this.relateTableArr),
            apiAr: list,
            apiArTwo: listTwo,
            id: _this.ruleForm.id
          }
          let res = await this.$http.channelSaveOrUpdate(data)
          if (res) {
            this.$message.success('操作成功！');
            this.getTableList()
            this.dialogVisible=false
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    eidt(row) {
      this.relateTableArr=[]
      this.ruleForm={}
      this.ruleForm.id = row.id
      this.ruleForm.channelName = row.channelName
      this.ruleForm.channelUserId = row.channelUserId
      this.ruleForm.apiAr = row.apiArList
      this.ruleForm.apiArTwo = row.apiArTwoList
      console.log(row.nodeList)
      row.nodeList.map((x)=>{
        this.relateTableArr.push(x.nodeNumber)
      })
      this.dialogVisible= true
    },
    addFunc() {
      this.$nextTick(() => {
				this.$refs['ruleForm'].resetFields()
			})
      this.relateTableArr=[]
      this.ruleForm={
        channelName: '',
        channelUserId: '',
        id: '',
        apiAr: [
          {
            sysUserId:'',
            shareName: '',
            shareRatio: ''
          }
        ],
        apiArTwo: [
          {
            sysUserId:'',
            shareName: '',
            shareRatio: ''
          }
        ]
      }
      this.dialogVisible=true
    },
    addApis() {
      this.ruleForm.apiAr.push({ ...this.apiAr });
    },
    addApisTwo(){
      this.ruleForm.apiArTwo.push({ ...this.apiArTwo });
    },
    delAdd(i) {
      //删除api
      let self = this;
      self.ruleForm.apiAr.splice(i, 1);
    },
    delAddTwo(i) {
      //删除api
      let self = this;
      self.ruleForm.apiArTwo.splice(i, 1);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 获取节点
    async nodeList() {
      let res = await this.$http.nodeALL()
      if (res)
      res.data.map((x)=>{
        this.dataArr.push({
          key: x.nodeNumber,
          label: x.nodeNumber
        })
      })
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.channelList({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          this.totalNum = Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.modul_box{
  min-height: 600px;
}
.bigBox{
  padding: 0 22px;
  max-height: 570px;
  overflow-y: scroll;
}
.samll_title{
  display: flex;
  align-content: center;
  justify-content: space-between;
}
.title_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size:16px;
  font-weight:bold;
  margin-bottom:10px
}
.delBtn{
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
.nodeBox{
  padding-left: 20px;
}
</style>
